import { createAsyncThunk } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

//Include Both Helper File with needed methods
import {
	getWaterSourceList as getWaterSourceListApi,
	getWaterSourceListQuery as getWaterSourceListQueryApi,
	getWaterSource as getWaterSourceApi,
	addNewWaterSourceApi,
	updateWaterSourceApi,
	deleteWaterSourceApi,
	checkWaterSourceExistsApi,
} from '../../helpers/water_source/api_helper';

export const getWaterSourceList = createAsyncThunk(
	'waterSource/getWaterSourceList',
	async () => {
		try {
			const response = await getWaterSourceListApi();
			// Extract data array from response
			return response.data || response;
		} catch (error) {
			toast.error('Error al obtener las fuentes de agua.', {
				autoClose: 3000,
			});
			throw new Error(error);
		}
	}
);

export const getWaterSourceListQuery = createAsyncThunk(
	'waterSource/getWaterSourceListQuery',
	async params => {
		try {
			const response = getWaterSourceListQueryApi(params);
			return response;
		} catch (error) {
			throw new Error(error);
		}
	}
);

export const getWaterSource = createAsyncThunk(
	'waterSource/getWaterSource',
	async water_source_id => {
		try {
			const response = await getWaterSourceApi(water_source_id);
			return response;
		} catch (error) {
			toast.error('Error al obtener la fuente de agua.', {
				autoClose: 3000,
			});
			throw new Error(error);
		}
	}
);

export const addNewWaterSource = createAsyncThunk(
	'waterSource/addNewWaterSource',
	async water_source => {
		try {
			const response = await addNewWaterSourceApi(water_source);
			toast.success('Fuente de Agua agregada exitosamente.', {
				autoClose: 3000,
			});
			// Extract data from response if it's wrapped
			return response.data || response;
		} catch (error) {
			toast.error('Error al agregar la fuente de agua.', {
				autoClose: 3000,
			});
			throw new Error(error);
		}
	}
);

export const updateWaterSource = createAsyncThunk(
	'waterSource/updateWaterSource',
	async water_source => {
		try {
			const response = await updateWaterSourceApi(water_source);
			toast.success('Fuente de Agua actualizada exitosamente.', {
				autoClose: 3000,
			});
			// Extract data from response if it's wrapped
			return response.data || response;
		} catch (error) {
			toast.error('Error al actualizar la fuente de agua.', {
				autoClose: 3000,
			});
			throw new Error(error);
		}
	}
);

export const deleteWaterSource = createAsyncThunk(
	'waterSource/deleteWaterSource',
	async water_source => {
		try {
			const response = await deleteWaterSourceApi(water_source._id);
			toast.success('Fuente de Agua eliminada exitosamente.', {
				autoClose: 3000,
			});
			// Return the original object to identify which item to remove
			return water_source;
		} catch (error) {
			toast.error('Error al eliminar la fuente de agua.', {
				autoClose: 3000,
			});
			throw new Error(error);
		}
	}
);

export const checkWaterSourceExists = createAsyncThunk(
	'waterSource/checkWaterSourceExists',
	async name => {
		try {
			const response = await checkWaterSourceExistsApi(name);
			return response;
		} catch (error) {
			return { exists: false };
		}
	}
);
